/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-27 14:52:41
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App';
//路由
import routes from './routes'
import { wxAuthorization, checkToken } from "@/api/api"
import { Field,Form,Toast} from 'vant';
import '@/js/clipboard';//文本复制

//默认样式
import './styles/reset.css'
//公共样式
import './styles/index.css'
//主样式
import './styles/main.css'
//vuex
import store from './store'
//
import {wxAuthLogin} from '@/js/auther'
import {constJs} from '@/js/constJs'
// sessionStorage
import '@/js/sessionStorage'

//svg-icon
import '@/icons' // icon

import md5 from 'js-md5';
import { getCookie, setCookie,aseEncode,aseDecode } from '@/js/utils';


//md5加密
Vue.prototype.$md5 = md5


Vue.config.productionTip = false;

//获取cookie方法挂载于Vue 
Vue.prototype.$getCookie = getCookie
    //设置cookie方法挂载于Vue 
Vue.prototype.$setCookie = setCookie
// 加密解密
Vue.prototype.$aseEncode = aseEncode
Vue.prototype.$aseDecode = aseDecode



// 常量
Vue.prototype.$constJs = constJs


Vue.use(Toast);
//将ajax和请求地址url挂载于Vue
// Vue.prototype.$ajax = ajaxServer
//toast方法挂载于Vue
Vue.prototype.$toast = (msg, type = 'warning', time = 2000, showClose = false) => {
    Toast({
        message: msg,
        type: type,
        duration: time
    })
}
    //load方法挂载于Vue
    /*
     * target: 需要覆盖的 DOM 节点   object/string
     * text: 显示在加载图标下方的加载文案
     * spinner: 自定义加载图标类名
     */
Vue.prototype.$load = {
    instance: null,
    loading(target = document.body, text = '', spinner = '') {
        this.instance = Vue.prototype.$loading({
            target,
            text,
            spinner
        })
    },
    loaded() {
        if (this.instance) this.instance.close()
        this.instance = null
    }
}



const router = new VueRouter({
    mode: "history",
    routes
})

Vue.use(VueRouter);

router.beforeEach((to, from, next) => {
    // if (to.meta.indicator || document.querySelector("#content")) { //需要loading效果时
    //     Vue.prototype.$load.loading("#content")
    // }
    /* 路由发生变化修改页面title */ 
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.meta.viewport) {
        var viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
    }else{
        var viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }
    if(to.meta.scroll){
        window.scrollTo(0, 0);
    }
    
    // setCookie("token",'eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIxMzAwNjE5MjY3MDE1ODM5NzQ0IiwiaWF0IjoxNTk5ODAyNjM1LCJleHAiOjMxOTk2MDUyNzB9.W8uCrm0qE56gzQUjuqct6QM3I1IaAbuZO_EQ0dVxvGE	',1 * 24 * 60 * 60 * 1000);
    if(to.meta.type == 'manager'){//管理员
        if(to.meta.ticket){
            if(!getCookie('ticket')){//没有获取到 token 的情况
                next({
                    name: to.meta.login,
                    query: {redirect: to.fullPath} //登录后再跳回此页面时要做的配置
                });
            }else {// 获取到 token 的情况
                next()
            }
        }else{
            next();
        }
    }else{
        if(to.meta.token){
            if(!getCookie('token')){//没有获取到 token 的情况
                next({
                    name:'wxAuther',
                    query:{redirect: to.fullPath}
                });
            }else {// 获取到 token 的情况
                next()
            }
        }else{
            next();
        }
    }
    // next();
})

router.afterEach(function(to) {
    to.meta.routeList = {
        name: to.name,
        path: to.path
    }
    if (to.meta.indicator || document.querySelector("#content")) { //需要loading效果时
        setTimeout(function() {
            Vue.prototype.$load.loaded()
        }, 300)
    }
});

Vue.mixin({

})

// 监听返回按钮
// window.addEventListener('popstate', function(e) {
// 	 router.back(-1)   // router已经在上面import进来
// }, false)

new Vue({
    el: '#app',
    template: '<App/>',
    components: {
        App
    },
    router,
    store,
})


// WEBPACK FOOTER //
// ./src/main.js